import type { ExtendWithOption } from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';

export type ProspectAvailability = 'active' | 'unlockable' | 'unavailable';

export const getProspectAvailability = (
  isProspectEntitledAndSelected: boolean,
  selectedUnentitledExtensions: readonly ExtendWithOption[]
): ProspectAvailability => {
  if (isProspectEntitledAndSelected) return 'active';

  return selectedUnentitledExtensions.includes('prospect')
    ? 'unlockable'
    : 'unavailable';
};
